module.exports = __webpack_public_path__ + "img/HomeActive.0e0fa564.png";